import { createCrudSlice } from "./createCrudSlice";
import {
  ADD_USER,
  DELETE_USER,
  GET_USER_DETAILS,
  GET_USERS,
  RESEND_INVITE,
  UPDATE_MPIN,
  UPDATE_PASSWORD,
  UPDATE_USER,
  UPDATE_USER_STATUS,
} from "helpers/url_helper";

const usersSlice = createCrudSlice({
  name: "users",
  urls: {
    getList: GET_USERS,
    add: ADD_USER,
    update: UPDATE_USER,
    updateMethod: "put",
    delete: DELETE_USER,
    updateStatus: UPDATE_USER_STATUS,
    getDetails: GET_USER_DETAILS,
  },
  initialFilters: {},
  additionalThunks: {
    resendInvite: {
      type: "users/resendInvite",
      url: (id) => `${RESEND_INVITE}/${id}`,
      method: "get",
      loadingKey: "isLoading",
    },
    updatePassword: {
      type: "users/updatePassword",
      url: () => `${UPDATE_PASSWORD}`,
      method: "put",
      loadingKey: "isLoading",
    },
    updateMpin: {
      type: "users/updateMpin",
      url: () => `${UPDATE_MPIN}`,
      method: "put",
      loadingKey: "isLoading",
    },

  },
  initialState: {
    // users: [],
    // userDetails: {},
    accountType : ""
  },
});

// Export actions
export const { setFilter, resetFilters } = usersSlice.actions;

// Export thunks
export const {
  getList: getUsers,
  add: addUser,
  update: updateUser,
  delete: deleteUser,
  updateStatus: updateUserStatus,
  getDetails: getUserDetails,
  resendInvite,
  updatePassword,
  updateMpin
} = usersSlice.thunks;

// Export reducer
export default usersSlice.reducer;

// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { type } from "@testing-library/user-event/dist/type";
// import { makeThunk } from "helpers/makeThunk";
// import { handleCommonCases } from "helpers/thunkHandler";
// import {
//   ADD_USER,
//   DELETE_USER,
//   GET_USER_DETAILS,
//   GET_USERS,
//   RESEND_INVITE,
//   SET_PASSWORD,
//   UPDATE_USER,
//   UPDATE_USER_STATUS,
//   VERIFY_INVITE,
// } from "helpers/url_helper";

// export const getUsers = makeThunk({ url: GET_USERS });
// export const addUser = makeThunk({ url: ADD_USER });
// export const updateUser = makeThunk({ url: UPDATE_USER, method: "put" });
// export const deleteUser = makeThunk({ url: DELETE_USER, method: "delete" });
// export const updateUserStatus = makeThunk({
//   url: UPDATE_USER_STATUS,
//   method: "patch",
// });
// export const resendInvite = makeThunk({
//   url: (id) => `${RESEND_INVITE}/${id}`,
//   method: "get",
// });
// export const getUserDetails = makeThunk({
//   url: (id) => `${GET_USER_DETAILS}/${id}`,
//   type: (id) => `${GET_USER_DETAILS}/${id}`,
//   method: "get",
// });

// const initialState = {
//   loading: false,
//   isLoading: false,
//   totalCount: null,
//   totalPages: null,
//   currentPage: null,
//   loadingItemId: null,
//   users: [],
//   filters: {
//     keyword: "",
//     status: -1,
//     dates: [],
//     role: [],
//   },
//   userDetails: {},
// };

// const usersSlice = createSlice({
//   name: "users",
//   initialState,
//   reducers: {
//     setFilter: (state, action) => {
//       const { key, value } = action.payload;
//       state.filters[key] = value; // updates only one filter
//     },

//     resetFilters: (state) => {
//       state.filters = initialState.filters; // RESET to default
//     },
//   },

//   extraReducers: (builder) => {
//     handleCommonCases(builder, getUsers, {
//       onFulfilled: (state, action) => {
//         const { data, totalCount, totalPages, currentPage } =
//           action.payload || {};
//         state.users = data || [];
//         state.totalCount = totalCount;
//         state.totalPages = totalPages;
//         state.currentPage = currentPage;
//       },
//     });

//     handleCommonCases(builder, addUser, { loadingKey: "isLoading" });

//     handleCommonCases(builder, updateUser, { loadingKey: "isLoading" });

//     handleCommonCases(builder, resendInvite, { loadingKey: "isLoading" });

//     handleCommonCases(builder, getUserDetails, {
//       onFulfilled: (state, action) => {
//         const { data } = action.payload || {};
//         state.userDetails = data || {};
//       },
//     });

//     handleCommonCases(builder, deleteUser, {
//       loadingKey: "isDeleting",
//       onFulfilled: (state, action) => {
//         const deletedId = action.meta.arg.id;
//         state.users = state.users.filter((item) => item._id !== deletedId);
//       },
//     });

//     handleCommonCases(builder, updateUserStatus, {
//       loadingKey: "isLoading",
//       onPending: (state, action) => {
//         state.loadingItemId = action.meta.arg._id;
//       },
//       onFulfilled: (state, action) => {
//         const { id, status } = action.meta.arg;
//         const user = state.users.find((item) => item._id === id);
//         if (user) {
//           user.status = status;
//         }
//         state.loadingItemId = null;
//       },
//       onRejected: (state) => {
//         state.loadingItemId = null;
//       },
//     });
//   },
// });

// export const { setFilter, resetFilters } = usersSlice.actions;

// export default usersSlice.reducer;
